import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-envelopeopen",
  "use": "icon-th-envelopeopen-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-envelopeopen\">\n<path d=\"M28.555 11.1675L16.555 3.16751C16.3907 3.05787 16.1975 2.99936 16 2.99936C15.8025 2.99936 15.6093 3.05787 15.445 3.16751L3.445 11.1675C3.30801 11.2589 3.19572 11.3827 3.11809 11.5279C3.04046 11.6732 2.99989 11.8353 3 12V25C3 25.5304 3.21071 26.0392 3.58579 26.4142C3.96086 26.7893 4.46957 27 5 27H27C27.5304 27 28.0391 26.7893 28.4142 26.4142C28.7893 26.0392 29 25.5304 29 25V12C29.0001 11.8353 28.9595 11.6732 28.8819 11.5279C28.8043 11.3827 28.692 11.2589 28.555 11.1675ZM12.09 19L5 24V13.9413L12.09 19ZM14.1362 20H17.8638L24.9425 25H7.0575L14.1362 20ZM19.91 19L27 13.9413V24L19.91 19ZM16 5.20126L26.2388 12.0275L17.8638 18H14.1388L5.76375 12.0275L16 5.20126Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-envelopeopen.svg
// module id = UENv
// module chunks = 84